import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getQuestionnaireUrl as _getQuestionnaireUrl } from '@/api/modules/questionnaire.js';
export default {
  name: 'QuestionnaireDialog',
  props: {
    questionnaireList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    // 获取问卷链接
    getQuestionnaireUrl: function getQuestionnaireUrl(item) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, _yield$_getQuestionna, status, data, tempTagA;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {
                  shortId: item.shortId
                };
                _context.next = 3;
                return _getQuestionnaireUrl(params);

              case 3:
                _yield$_getQuestionna = _context.sent;
                status = _yield$_getQuestionna.status;
                data = _yield$_getQuestionna.data;

                if (!(status !== 1)) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return");

              case 8:
                // window.open(data, '_blank')
                tempTagA = document.createElement('a');
                tempTagA.href = data;
                tempTagA.target = '_blank';
                tempTagA.click();

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 关闭当前dialog
    closeDialog: function closeDialog() {
      this.$emit('toggleQuestionnaire');
    }
  }
};